<div class="verify-center">
	<div class="card-heading">
		<h2 class="row-center title content-title" i18n="@@registerUser-verifyMobileTitle">Verify Mobile Number</h2>

		<p class="font-14 content-subtitle center" i18n="@@registerUser-verifyMobileCodeSent">
			Code sent to {{ this.mobilePhoneNumber?.rawPhoneNumber }}
		</p>

		<p class="font-14 center blue" i18n="@@registerUser-verifyMobileCodeConfirmMessage">
			Please confirm the 6-digit verification code
		</p>
	</div>

	<div class="main-card-content">
		<app-verification-code
			(verificationCodeEventResult)="verificationCodeEventResult($event)"
			[userId]="this.userId"
			[mobilePhoneNumber]="this.mobilePhoneNumber?.rawPhoneNumber"
			[mobileCountryCode]="this.mobilePhoneNumber?.countryCode"
			[mode]="this.mode"
		>
		</app-verification-code>

		<div class="column-center center-unset-width" style="margin: 16px 0px 32px 0px">
			<button
				mat-button
				data-automation-id="verify-number-resend-code-button"
				class="secondary-button"
				(click)="onResendClicked()"
				i18n="@@registerUser-verifyMobileResendCode"
			>
				Resend Code
			</button>
		</div>
	</div>

	<div class="button-spacing">
		<button
			mat-button
			data-automation-id="verify-number-back-button"
			class="secondary-button"
			i18n="@@registerUser-verifyMobileBack"
			(click)="onBackButtonClicked()"
		>
			Back
		</button>

		<button
			mat-button
			data-automation-id="verify-number-next-button"
			class="primary-button"
			i18n="@@registerUser-verifyMobileNext"
			[disabled]="this.isNextButtonDisabled"
			(click)="onNextButtonClicked()"
		>
			Next
		</button>
	</div>
</div>
